import { QueryObserver } from '@tanstack/vue-query';
import queryClient from './queryClient.js';
import { queries } from './index.js';

/**
 * A class to be used as a singleton that holds the app's QueryObservers
 */
class QueryObservers {
  observers = {};

  /**
   * Initialize the observers with the default
   */
  init() {
    // this.create('currentWorkspace', queries.workspace.current);
  }

  /**
   * Create an observer. The key will be used to identify (and override) observers
   * @param {String} name The name of the observer
   * @param {any} options The QueryObserver options (same as useQuery)
   */
  create(name, options) {
    const observer = new QueryObserver(queryClient, {
      ...options,
      refetchOnWindowFocus: false,
    });

    const unsubscribe = observer.subscribe(() => {});

    if (this.observers[name]) {
      this.observers[name].unsubscribe();
    }

    this.observers[name] = {
      observer,
      unsubscribe,
    };
  }

  /**
   * The name of the observer to unsubscribe from.
   * @param {String} name The name of the observer
   */
  unsubscribe(name) {
    this.observers[name]?.unsubscribe();
  }
}

const observers = Object.freeze(new QueryObservers());

export default observers;
